<p-card [header]="activityDescription | async">
  <div class="p-grid">
    <div class="p-col entriesform">
      <p-table [value]="builderEntries" dataKey="id" [rowTrackBy]="rowTrackBy" [autoLayout]="true" [resizableColumns]="false"
               [sortField]="defaultSort" [sortOrder]="sortOrder" (sortFunction)="customSort($event)" [customSort]="true">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="builder">Builder <p-sortIcon field="builder"></p-sortIcon></th>
            <th *ngIf="isBuilderRepairs | async" pSortableColumn="tableNumber">Table # <p-sortIcon field="tableNumber"></p-sortIcon></th>
            <th>{{ getUnitLabel() }}</th>
            <th *ngIf="showSecondaryCount">Premium <br> {{ getUnitLabel() }}</th>
            <th *ngIf="showQuality">{{ getUnitLabel() }} <br> Audited</th>
            <th *ngIf="showQuality">Failed <br> {{ getUnitLabel() }}</th>
            <th *ngIf="showNonProductiveHours">Non Productive <br> Time (Hours)</th>
            <th *ngIf="showQuality">Quality</th>
            <th *ngIf="showQuality">Allowed <br> Bad</th>
            <th *ngIf="showQuality">After <br> Penalty</th>
            <th *ngIf="isBuilderRepairs | async">After <br> Adjustment</th>
            <th *ngIf="showMetAttendanceGoal">Weekly Attendance <br> Goal Met</th>
            <th>Delete</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
          <tr [formGroup]="rowData">
            <td>
              <p-dropdown [options]="builderSelects" formControlName="builderId" placeholder="-- None --"
                name="builder" [required]="true" [filter]="true" [resetFilterOnHide]="true" appendTo="body">
              </p-dropdown>
            </td>
            <td *ngIf="isBuilderRepairs | async">
              <p-dropdown [options]="tableNumber" formControlName="tableNumber" name="tableNumber" appendTo="body">
              </p-dropdown>
            </td>
            <td class="centered">
              <input pInputText type="text" formControlName="count" name="count" class="columnWidth" required lib-numeric />
            </td>
            <td class="centered" *ngIf="showSecondaryCount">
              <input pInputText type="text" formControlName="secondaryCount"  class="columnWidth" name="secondaryCount" required lib-numeric />
            </td>
            <td class="centered" *ngIf="showQuality">
              <input pInputText type="text" formControlName="auditedCount" class="columnWidth" name="auditedCount" required lib-numeric />
            </td>
            <td class="centered" *ngIf="showQuality">
              <input pInputText type="text" formControlName="failedCount" name="failedCount" class="columnWidth" required lib-numeric />
            </td>
            <td class="centered" *ngIf="showNonProductiveHours">
              <input pInputText type="text" formControlName="nonProductiveHours"  name="nonProductiveHours" class="columnWidth" required />
            </td>
            <td class="centered boldNumber" *ngIf="showQuality">
              {{ rowData.quality | async }}
            </td>
            <td class="centered boldNumber" *ngIf="showQuality">
              {{ rowData.allowedBad | async }}
            </td>
            <td class="centered boldNumber" *ngIf="showQuality">
              {{ rowData.afterPenalty | async }}
               </td>
            <td class="centered boldNumber" *ngIf="isBuilderRepairs | async">
              {{ rowData.afterAdjustment | async }}
            </td>
            <td class="centeredCheckboxInTable" *ngIf="showMetAttendanceGoal">
              <p-checkbox formControlName="metAttendanceGoal" [binary]="true" name="metAttendanceGoal"></p-checkbox>
            </td>
            <td class="centered">
              <confirmation-button [iconsOnly]="true" actionIcon="pi pi-times" actionText="Delete"
                confirmIcon="pi pi-times" confirmText="Delete" cancelIcon="pi pi-minus-circle" cancelText="Cancel"
                (actionConfirmed)="deleteBuilderEntry(rowData)" [disabled]="rowData.disabled" [working]="(loadingDelete | async) === rowData.id">
              </confirmation-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="columnsCount" class="centered">
              No data available
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr [formGroup]="addForm">
            <td>
              <p-dropdown [options]="builderSelects" [required]="true" [editable]="false" [filter]="true" formControlName="builderId"
                placeholder="-- Select Builder --" class="form-control" name="builder" [resetFilterOnHide]="true" appendTo="body"></p-dropdown>
              <error-block [field]="addForm.get('builderId')" [messages]="{
                required: 'Builder is required.'
              }">
              </error-block>
            </td>
            <td *ngIf="isBuilderRepairs | async">
              <p-dropdown [options]="tableNumber" [editable]="false" name="tableNumber" formControlName="tableNumber" appendTo="body">
              </p-dropdown>
            </td>
            <td class="centered">
              <input type="text" lib-numeric pInputText required name="count" formControlName="count"
               class="form-control columnWidth" (keyup)="calculateAddFormQuality()"/>
              <error-block [field]="addForm.get('count')" [messages]="{
                      required: 'Count is required.'
              }">
              </error-block>
            </td>
            <td *ngIf="showSecondaryCount" class="centered">
              <input type="text" lib-numeric pInputText name="secondaryCount" formControlName="secondaryCount"
                class="form-control columnWidth" (keyup)="calculateAddFormQuality()"/>
              <error-block [field]="addForm.get('secondaryCount')" [messages]="{
                      requiredIf: 'Count is required.'
              }">
              </error-block>
            </td>
            <td *ngIf="showQuality" class="centered">
              <input type="text" lib-numeric pInputText name="auditedCount" formControlName="auditedCount"
                class="form-control columnWidth" (keyup)="calculateAddFormQuality()"/>
              <error-block [field]="addForm.get('auditedCount')" [messages]="{
                requiredIf: 'Pallets Audited is required.'
              }">
              </error-block>
            </td>
            <td *ngIf="showQuality" class="centered">
              <input type="text" lib-numeric pInputText name="failedCount" formControlName="failedCount"
                class="form-control columnWidth" (keyup)="calculateAddFormQuality()"/>
              <error-block [field]="addForm.get('failedCount')" [messages]="{
                requiredIf: 'Failed Pallets is required.'
              }">
              </error-block>
            </td>
            <td *ngIf="showNonProductiveHours" class="centered">
              <input type="text" pInputText name="nonProductiveHours" formControlName="nonProductiveHours"
                class="form-control columnWidth" (change)="onChangeNonProductiveHours()"/>
              <error-block [field]="addForm.get('nonProductiveHours')" [messages]="{
                requiredIf: 'Non Productive Hours is required.'
              }">
              </error-block>
            </td>
            <td *ngIf="showQuality" class="centered">
              <input type="text" pInputText id="quality" name="quality" formControlName="quality" class="form-control columnWidth"/>
            </td>
            <td *ngIf="showQuality"></td>
            <td *ngIf="showQuality"></td>
            <td *ngIf="isBuilderRepairs | async"></td>
            <td *ngIf="showMetAttendanceGoal" class="centeredCheckboxInTable">
              <p-checkbox class="wfsFormCheckbox" id="metAttendanceGoal" formControlName="metAttendanceGoal"
               [binary]="true" name="metAttendanceGoal"></p-checkbox>
            </td>
            <td class="centered">
              <button pButton type="button"
                    [disabled]="addForm.disabled"
                    [icon]="(loadingPost | async) ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"
                    (click)="createBuilderEntry();"
                    label="Add"
                    [ngClass]="{ 'p-state-disabled': !addForm.valid }">
                  </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-card>
